import React from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { Clickable } from "../Clickables";
import { useHeaderContext } from "./HeaderContext";

import styles from "./Underlay.module.scss";

export const Underlay = () => {
    const {
        activeSubmenu,
        setActiveSubmenu,
        mobileMenuOpen,
        setMobileMenuOpen,
    } = useHeaderContext();

    if (!activeSubmenu && !mobileMenuOpen) return null;

    const close = () => {
        setActiveSubmenu(null);
        setMobileMenuOpen(false);
    };

    return (
        <Clickable
            className={styles.underlay}
            onPointerMove={(e: React.PointerEvent) => {
                if (e.pointerType === "mouse" && !mobileMenuOpen) {
                    setActiveSubmenu(null);
                }
            }}
            onPress={close}
        >
            <VisuallyHidden>{t`Close menu`}</VisuallyHidden>
        </Clickable>
    );
};
